import React from "react";

import { useTranslation, Trans } from "react-i18next";

import image from '../../img/MarketsCrypto/image.png'

import Button from '../Button'

import Fade from "react-reveal/Fade";

function WhatIsCrypto () {

    const { t } = useTranslation();
      
    return(
        <div className="relative pt-[90px] xl:pt-[160px]">
            <div className="max-w-[1220px] xl:mx-auto mx-[20px] relative">
                <div className="flex flex-col xl:flex-row justify-between">
                    <div className="hidden xl:block">
                        <Fade left delay={500}><img src={image} alt="" /></Fade>
                    </div>
                    <div className="xl:max-w-[489px]">
                        <p className="spantext text-[#0C2780] font-[700] text-[23px] xl:text-[45px] open-sans"><Trans>{t('marketscrypto.3')}</Trans></p>
                        <div className="mt-[30px] flex flex-col gap-[15px] xl:max-w-[495px]">
                            <p className="fontfont open-sans text-[16px] font-[300] text-[#0C2780]"><Trans>{t('marketscrypto.4')}</Trans></p>
                            <p className="fontfont open-sans text-[16px] font-[300] text-[#0C2780]"><Trans>{t('marketscrypto.5')}</Trans></p>
                        </div>
                        <Button color={'#15318D'} text={'#FFFFFF'} className={'mt-[30px] xl:mt-[40px]'}/>             
                    </div>
                </div>
                <div className="xl:flex absolute bottom-0 right-0 hidden">
                    <Fade right delay={100}><div className="h-[118px] w-[226px] bg-[#0C2780] flex flex-col justify-center items-center relative border-r border-[#EFEFEF]">
                        <p className="font-[600] text-[16px] open-sans text-[#EFEFEF]">{t('home.46')}</p>
                        <svg className="absolute bottom-[10px] right-[15px]" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                            <path d="M5 12.0161L19 12.0161" stroke="#EFEFEF" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 19.0161L19 12.0161L12 5.01611" stroke="#EFEFEF" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div></Fade>
                    <Fade right delay={300}><div className="h-[118px] w-[226px] bg-[#0C2780] flex flex-col justify-center items-center relative border-r border-[#EFEFEF]">
                        <p className="font-[600] text-[16px] open-sans text-[#EFEFEF]">{t('home.47')}</p>
                        <svg className="absolute bottom-[10px] right-[15px]" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                            <path d="M5 12.0161L19 12.0161" stroke="#EFEFEF" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 19.0161L19 12.0161L12 5.01611" stroke="#EFEFEF" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div></Fade>
                    <Fade right delay={500}><div className="h-[118px] w-[226px] bg-[#0C2780] flex flex-col justify-center items-center relative border-r border-[#EFEFEF]">
                        <p className="font-[600] text-[16px] open-sans text-[#EFEFEF]">{t('home.48')}</p>
                        <svg className="absolute bottom-[10px] right-[15px]" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                            <path d="M5 12.0161L19 12.0161" stroke="#EFEFEF" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 19.0161L19 12.0161L12 5.01611" stroke="#EFEFEF" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div></Fade>
                    <Fade right delay={700}><div className="h-[118px] w-[226px] bg-[#0C2780] flex flex-col justify-center items-center relative border-r border-[#EFEFEF]">
                        <p className="font-[600] text-[16px] open-sans text-[#EFEFEF]">{t('home.49')}</p>
                        <svg className="absolute bottom-[10px] right-[15px]" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                            <path d="M5 12.0161L19 12.0161" stroke="#EFEFEF" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M12 19.0161L19 12.0161L12 5.01611" stroke="#EFEFEF" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div></Fade>
                </div>
            </div>
        </div>
    );
}

export default WhatIsCrypto;